import { render, staticRenderFns } from "./ProductStockStatus.vue?vue&type=template&id=af0fc55c&scoped=true&"
import script from "./ProductStockStatus.vue?vue&type=script&lang=js&"
export * from "./ProductStockStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0fc55c",
  null
  
)

export default component.exports